import type { CustomChartSize, CustomChartType } from './types';

export const TREND_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

/** Каталог типов диаграмм пользовательского дашборда в порядке показа пользователю. */
export const CUSTOM_CHART_TYPES: readonly CustomChartType[] = [
  'metric',
  'text-summary',
  'heatmap',
  'table',
  'grouped-table',
  'bar',
  'pie',
  'line',
  'conversation-list',
  'selection-breakdown',
] as const;

/** Размеры диаграммы от узкого к широкому — доля ширины сетки дашборда. */
export const CUSTOM_CHART_SIZES: readonly CustomChartSize[] = ['1/5', '1/4', '1/3', '1/2', 'full'] as const;

/**
 * Размеры, рекомендуемые для типа диаграммы: предлагаются первыми, но выбор пользователя
 * ими не ограничен — доступен любой размер из {@link CUSTOM_CHART_SIZES}.
 */
export const RECOMMENDED_CHART_SIZES: Record<CustomChartType, CustomChartSize[]> = {
  metric: ['1/5', '1/4'],
  'text-summary': ['1/3', '1/2', 'full'],
  heatmap: ['1/2', 'full'],
  table: ['1/2', 'full'],
  'grouped-table': ['1/2', 'full'],
  bar: ['1/3', '1/2', 'full'],
  pie: ['1/3', '1/2'],
  line: ['1/2', 'full'],
  'conversation-list': ['1/3', '1/2', 'full'],
  'selection-breakdown': ['1/3', '1/2', 'full'],
};

/**
 * Минимальное число диаграмм в пользовательском дашборде. Сверху состав не ограничен: он растёт
 * строками сетки, а пять диаграмм в строке — предел её ширины, а не состава.
 */
export const MIN_PRESET_CHARTS = 1;

/** Предельная длина описания данных диаграммы — граница задана контрактом истолкования. */
export const CHART_DESCRIPTION_MAX_LENGTH = 1000;

/** Наименьшая длина описания данных диаграммы, при которой бэкенд берётся его истолковать. */
export const CHART_DESCRIPTION_MIN_LENGTH = 3;
